var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9167 10.9177C24.9167 10.0621 24.223 9.36834 23.3673 9.36834H6.3743L12.6726 3.49611C13.3183 2.93445 13.3865 1.95601 12.8248 1.3103C12.2636 0.664583 11.2847 0.59641 10.639 1.15768C10.6111 1.18208 10.584 1.20765 10.5577 1.23399L1.38136 9.7828C0.755789 10.3665 0.721702 11.3469 1.30505 11.9725C1.32984 11.9988 1.35502 12.0244 1.38136 12.0488L10.5577 20.6015C11.1833 21.1856 12.164 21.1515 12.7481 20.526C13.3323 19.9004 13.2982 18.9196 12.6726 18.3355L6.3743 12.4671H23.3673C24.223 12.4671 24.9167 11.7734 24.9167 10.9177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.77e625d0ac76adde42beb381cad652a6.svg";
export { ForwardRef as ReactComponent };